module.exports = __webpack_public_path__ + "img/s2.7368d460.png";